export default __webpack_public_path__ + "static/media/UserLightActive.fdd5dbaf.svg";